var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteiconmainactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5371 13.0508L13.5487 19.0403C13.1517 19.4372 12.6133 19.6602 12.0519 19.6602C11.4905 19.6602 10.9521 19.4372 10.5551 19.0403L4.56668 13.0519C4.07166 12.5612 3.67843 11.9775 3.40958 11.3345C3.14072 10.6914 3.00154 10.0015 3.00001 9.30449C2.99849 8.60747 3.13465 7.91701 3.40068 7.27275C3.66672 6.62849 4.05739 6.04313 4.55026 5.55026C5.04313 5.05739 5.62849 4.66672 6.27275 4.40068C6.91701 4.13465 7.60747 3.99849 8.30449 4.00001C9.00152 4.00154 9.69137 4.14072 10.3345 4.40958C10.9775 4.67843 11.5612 5.07166 12.0519 5.56668C13.0486 4.59477 14.3881 4.05467 15.7803 4.0634C17.1724 4.07212 18.505 4.62896 19.4895 5.61328C20.4739 6.59761 21.031 7.93017 21.0399 9.32229C21.0488 10.7144 20.5089 12.054 19.5371 13.0508Z",
    fill: "#5070DE",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteiconmainactive);
export default __webpack_public_path__ + "static/media/favoriteiconmainactive.cec1069a3183012a3308666929b3c0e4.svg";
export { ForwardRef as ReactComponent };